import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider } from '@emotion/react';
import { GlobalStylesProvider } from './../styles/index.js';
export const BrandingProvider = ({ theme, children, disableGlobalStyles }) => (_jsx(ThemeProvider, { theme: theme, children: !disableGlobalStyles ? (_jsx(GlobalStylesProvider, { children: children })) : (children) }));
//# sourceMappingURL=index.js.map